import classNames from 'classnames';
import Icon from 'components/styleguide/icon/Icon';
import React from 'react';

const styles = require('./Tag.module.scss');

export type TagVariant = 'neutral' | 'success' | 'info' | 'warning' | 'error';

export interface TagProps {
  children: React.ReactNode;
  className?: string;
  iconLeft?: string;
  iconRight?: string;
  variant?: TagVariant;
}

const Tag: React.FC<TagProps> = ({
  children,
  className,
  iconLeft,
  iconRight,
  variant = 'neutral',
}) => {
  return (
    <span className={classNames(styles.tag, styles[variant], className)}>
      {iconLeft && <Icon name={iconLeft} size="sm" color={`${variant}-border-base`} aria-hidden="true" />}
      {children}
      {iconRight && <Icon name={iconRight} size="sm" color={`${variant}-border-base`} aria-hidden="true" />}
    </span>
  );
};

export default Tag;
